// トグル(アコーディオン)表示
import commonClass from "./commonClass";

export default class switchChkStatusClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._trg = '.js-chk_trg';
    this._grp = '.js-chk_grp';
    //this._$trgによってコントロールされる要素
    this._trg_child = '.js-chk_trg-child';
    this._$trginner = $('.js-chk_trginner');
    this._grpinner = '.js-chk_grpinner';
    this._$trgitm = $('.js-chk_trgitm');
    this._trgitm = '.js-chk_trgitm';
    this._$trginnitm = $('.js-chk_trginnitm');
    this._trginnitm = '.js-chk_trginnitm';
    //this._grp = '.js-chk_grp';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    var _$trg = $(cls._trg);
    var _$trg_child = $(cls._trg_child);

    _$trg.on('change', function () {
      var $me = $(this);
      $me.parents(cls._grp).find('input').prop('checked', !$me.is(':checked'));
    });
    _$trg_child.on('change', function () {
      var $me = $(this);
      if (!$me.is(':checked')) {
        $me.parents(cls._grp).find(cls._trg).prop('checked', false);
      }
    });
    this._$trgitm.on('change', function () {
      var me = this;
      if ($(me).parent(cls._grp).find(cls._trgitm).not(':checked')) {
        $(me).parents(cls._grp).find('.js-chk_trg').prop('checked', false);
      }
    });

    // 二重全チェックの内側用
    this._$trginner.on('change', function () {
      var me = this;
      if ($(me).is(':checked')) {
        $(me).parents(cls._grpinner).find('input').prop('checked', true);
      } else {
        $(me).parents(cls._grpinner).find('input').prop('checked', false);
      }
      if ($(me).parent(cls._grpinner).find('.js-chk_trginner').not(':checked')) {
        $(me).parents(cls._grp).find('.js-chk_trg').prop('checked', false);
      }
    });
    this._$trginnitm.on('change', function () {
      var me = this;
      if ($(me).parent(cls._grpinner).find(cls._trginnitm).not(':checked')) {
        $(me).parents(cls._grpinner).find('.js-chk_trginner').prop('checked', false);
        $(me).parents(cls._grp).find('.js-chk_trg').prop('checked', false);
      }
    });
  }

}